module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Accedi al tuo account","pageMetaDescription":"Accedi al tuo account"}}')
  delete Component.options._Ctor
}
